import FrontDeskLayout from "./frontDeskLayout";

export default FrontDeskLayout;